import React, {useState} from 'react'
import flower from '../images/flower.png'
import ContactModal from '../components/ContactModal';

function Invitation() {

  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  function FamilyInfo({dad, mom, child, relation}) {
    return (
      <div className='invitation__family'>
          <div className='invitaion__parent'>
              <div>{dad}·{mom}</div>
          </div>
          <div>{relation}</div>
          <div className='invitation__child'>{child}</div>
      </div>
    )
  }
  return (
    <div className='bc-pink container'>
        <img src={flower} className='flower' alt='flower'/>
        <div className='invitation__title'>초대합니다</div>
        <div className='invitation__content'>
          <div>오래전 작은 인연이</div>
          <div>우리를 연인으로 만들었고</div>
          <div>그 인연이 이제 하나가 됩니다.</div>
          <div></div>
          <div>하나 된 삶을 향해</div>
          <div>첫걸음을 내딛는 뜻깊은 날</div>
          <div>가벼운 발걸음으로 오셔서</div>
          <div>시작하는 모습을 함께해주시면</div>
          <div>감사하겠습니다.</div>
        </div>
        <FamilyInfo dad="상선" mom="한숙" child="정 민호" relation="의 장남" />
        <FamilyInfo dad="종열" mom="영순" child="김 지후" relation="의 장녀" />
        <button className='invitation__btn-contact' onClick={openModal}>연락하기</button>
        {isModalOpen && (
          <ContactModal closeModal={closeModal}/>
        )}
    </div>
  )
}

export default Invitation
